<template>
<div>

    <!-- <CardHeader :title="$t('terminals.announcements.header')" /> -->
    <h4>
        <b-icon icon="info-square" scale="1.0"></b-icon>
        <span>{{ $t('terminals.announcements.header') }}</span>
        <a v-if="!selectedAnnouncement" href="#" class="action-link" @click="onNewItem" v-b-tooltip :title="$t('button.add')"><b-icon icon="plus-circle-fill" scale="1.0"></b-icon></a>
        <a v-else  href="#" class="action-link" @click="onReset" v-b-tooltip :title="$t('button.close')"><b-icon icon="x" scale="1.8"></b-icon></a>
    </h4>

    <div v-if="!selectedAnnouncement">
        <!-- <TableActionHeader @newItem="onNewItem" :searchInput="false" /> -->
        <div v-if="!announcementItems || announcementItems.length == 0" class='info note'>
            {{ $t('terminals.announcements.no_announcements') }}
        </div>
        <b-table
            v-else
            style="white-space: pre-line;"
            small
            striped
            hover
            selectable
            select-mode="single"
            @row-selected="onRowSelected"
            :fields="announcementFields"
            :items="announcementItems"
            thead-tr-class="term-announcements-headtr"
            tbody-tr-class="term-announcements-bodytr">
            <template v-slot:cell(displays)="data">
                <div :title="data.value">{{ data.item.targets.displayTargets.length }}</div>
            </template>
        </b-table>
    </div>
    <div v-else>
        <TermAnnouncementEditor
            :selectedAnnouncement="selectedAnnouncement"
            :terminalId="terminalId"
            @reset="onReset" />
    </div>
</div>
</template>

<script>
import TermAnnouncementEditor from '@/components/Terminals/TermAnnouncementEditor.vue';
import terminalView from '@/store/terminals/terminalView';
import moment from 'moment';

export default {
	name: 'TerminalAnnouncements',
    components: { TermAnnouncementEditor },
    props: ['terminalId', 'activeTerminalId'],
    data: function() {
        return {
            selectedAnnouncement: null
        };
    },
    computed: {
        announcementFields() {
            return [
                { key: 'otsikko' , label: this.$t('terminals.announcements.name'), sortable: false },
                { key: 'content' , label: this.$t('terminals.announcements.content'), sortable: false, formatter: (value, key, item) => {
                        var text = '';
                        for (var i in item.tiedoteTextList) {
                            text += item.tiedoteTextList[i] + '\n';
                        }
                        return text;
                    }
                },
                { key: 'active', label: this.$t('terminals.announcements.active'), sortable: false, formatter: (value, key, item) => {
                        var time = this.formatTimestamp(item.kelpoisuusalkaa);
                        time += ' -\n';
                        var time2 = this.formatTimestamp(item.kelpoisuusloppuu);
                        return time + time2;
                    }
                },
                { key: 'displays' , label: this.$t('terminals.announcements.displays'), sortable: false, formatter: (value, key, item) => {
                        var displayList = '';
                        // Array.sort sorts elements in palce, hence a copy must first be made (in this case with ...).
                        for (var displayTarget of [ ...item.targets.displayTargets ].sort((x, y) => {
                                if (x.id < y.id) {
                                    return -1;
                                }
                                if (x.id > y.id) {
                                    return 1;
                                }
                                return 0;
                            })) {
                            if (displayList.length > 0) displayList += ', ';
                            displayList += displayTarget.id;
                        }
                        return displayList;
                    }
                }
            ];
        },
        announcementItems() {
            return this.$store.state.terminalView.announcementsByTerminal[this.terminalId];
        }
    },
    methods: {
        onNewItem() {
            this.selectedAnnouncement = {
                    tunnus: -1,
                    otsikko: '',
                    tiedoteTextList: {},
                    targets: { displayTargets: [] }
                };
        },
        onRowSelected(items) {
            if (items[0]) {
                this.selectedAnnouncement = { ...items[0] }; // Copy.
            }
        },
        onReset() {
            this.selectedAnnouncement = null;
        },
        formatTimestamp(timestamp) {
            return new moment(timestamp, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm');
        }
    },
    watch: {
        activeTerminalId() {
            //console.log("activeTerminalId");
            if (this.terminalId == this.activeTerminalId) {
                this.$store.dispatch('terminalView/getTerminalAnnouncements', this.terminalId);
            }
        }
    },
    created() {
		if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }
         this.$store.dispatch('terminalView/getTerminalAnnouncements', this.terminalId);
        //console.log("created");
    }
}
</script>

<style lang="scss">
.term-announcements-headtr th {
    font-size: 11px !important;
    padding: 5px !important;
}

.term-announcements-bodytr td {
    font-family: Verdana,Arial,Helvetica,sans-serif;
    font-size: 11px;
    color: #515151;
    padding: 2px 2px 2px 5px !important;
}
</style>